// extracted by mini-css-extract-plugin
var _1 = "FilePreviewVideo-moduledisabled__JXvpr";
var _2 = "FilePreviewVideo-moduleplay__G2mzF FileIconPlaceholder-modulefileIconPlaceholder__ZGAvo FileIcon-moduleFileIcon__sDjTw IconNG-moduleiconContainer__SxWZ0";
var _3 = "FilePreviewVideo-modulevideo__UJUWk";
export { _1 as "disabled", _2 as "play", _3 as "video" }
